


































































import { Component, Vue, Watch } from 'vue-property-decorator';
import TransactionService from '@/services/TransactionService';
import QRCode from 'qrcode';

const transactionService = new TransactionService();

@Component
export default class HengpayForm extends Vue {
  public amount: string = '';

  public loading: boolean = false;

  public promptpay: string = '';

  public countDown: string = '--:--';

  public orderData: { timeout: number; qrcode: string; orderId: string } = { timeout: 0, qrcode: '', orderId: '' };

  // eslint-disable-next-line class-methods-use-this
  async requestDepositQr() {
    this.loading = true;
    try {
      const { data } = await transactionService.requestQr(this.amount);
      if (data.error) {
        this.$store.commit('Snackbar/showNotification', { message: 'เกิดข้อผิดพลาดระหว่างขอ QRCode', error: true });
        return;
      }
      // eslint-disable-next-line max-len
      this.orderData = { timeout: data.order.timeout, qrcode: data.order.QRPromptpay, orderId: data.order.Ref2 };
      this.setCountDown();
    } catch (e) {
      console.log(e.message);
      this.$store.commit('Snackbar/showNotification', { message: e.message || 'เกิดข้อผิดพลาดระหว่างขอ QRCode', error: true });
    }
    this.loading = false;
  }

  async downloadQrCode() {
    if ((navigator as any).canShare && navigator.share) {
      const canvas = document.createElement('canvas');
      await QRCode.toCanvas(canvas, this.orderData.qrcode);
      const image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');

      const fetchResponse = await fetch(image);
      const blob = await fetchResponse.blob();

      const file = new File([blob], `order-${new Date().valueOf()}.png`, { type: blob.type });

      await navigator.share({
        files: [file],
        title: 'QRCode ฝากเงิน',
        text: 'QRCode นี้สำหรับใช้ฝากเงินเข้าเว็บ ufaauto565 เท่านั้น',
      } as any);
    } else {
      this.$store.commit('Snackbar/showNotification', { message: 'Browser ของท่านไม่รองรับการดาวน์โหลดรูปภาพนี้ กรุณาแคปหน้าจอแทน', error: true });
    }
  }

  @Watch('orderData.qrcode')
  async onQrCodeChange(value: string) {
    if (value) {
      const data = await QRCode.toDataURL(value);
      this.promptpay = data;
    }
  }

  setCountDown() {
    if (this.orderData.timeout > 0) {
      const countDown = setInterval(() => {
        const now = new Date().valueOf();

        const distance = this.orderData.timeout - now;

        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.countDown = `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;

        if (distance < 0) {
          clearInterval(countDown);
          this.countDown = 'หมดเวลา';
          this.resetData();
        }
      },
      1000);
    }
  }

  resetData() {
    this.orderData = { timeout: 0, qrcode: '', orderId: '' };
  }

  // eslint-disable-next-line class-methods-use-this
  async getPreviousOrder() {
    try {
      const { data } = await transactionService.getQr();
      if (data.error) {
        return;
      }
      // eslint-disable-next-line max-len
      this.orderData = { timeout: data.order.timeout, qrcode: data.order.QRPromptpay, orderId: data.order.Ref2 };
      this.setCountDown();
    } catch (e) {
      console.log(e);
    }
  }

  async mounted() {
    await this.getPreviousOrder();
  }
}
